'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgAttachment(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M11.464 8.179l-3.89 3.89c-.954.96-2.23.887-3.05.054-.827-.82-.9-2.09.06-3.044l5.382-5.388c.517-.518 1.33-.686 1.874-.135.551.551.377 1.35-.14 1.868L6.377 10.76c-.175.175-.376.12-.49.007a.337.337 0 01.013-.49l3.675-3.683c.242-.242.256-.604.02-.84a.589.589 0 00-.84.02L5.056 9.477c-.619.625-.598 1.599-.034 2.156.611.612 1.532.592 2.157-.033l5.355-5.362c1.095-1.088 1.088-2.533.1-3.52-.967-.955-2.439-.988-3.527.094L3.677 8.253c-1.397 1.397-1.33 3.453-.033 4.75 1.303 1.297 3.359 1.37 4.756-.027l3.931-3.924a.646.646 0 00-.013-.887c-.229-.235-.612-.215-.854.014z", fill: "currentColor" }))));
}

module.exports = SvgAttachment;
//# sourceMappingURL=Attachment.js.map
